import React from 'react';
import TaskAnswerItem from './AnswerItem';
import './style.css';

const TaskAnswerList = ({items, selectedWord, onSelectedWord, lessonList = undefined, kind, answers}) => {
  const data = items.split('|');
  const pos = {};

  return (
    <div className="col border-end p-3 h-100">
      <div className="d-flex flex-column align-items-start ps-4">
        {data.map((item, index) => (
          <TaskAnswerItem
            word={item}
            key={index}
            isSelected={
              kind === 'VOCABULARY' ? !!answers.find(x => x.words.includes(`~${item}`)) : selectedWord === item
            }
            onSelect={onSelectedWord}
          />
        ))}
      </div>
    </div>
  );
};

export default TaskAnswerList;
